import React from 'react'
import ViolationsList from './ViolationsList.jsx'
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";

const ViolationsListPage = () => {
  const navHeight = useSelector(selectNavHeight);
  
  return (
  <div  className="mx-auto w-full"
    style={{
      marginTop: navHeight,
      height: `calc(100vh - ${navHeight}px)`,
      overflow: "auto",
    }} >
      <ViolationsList />
    </div>
  );
}

export default ViolationsListPage